import axios from "axios"
import qs from "qs"
// constants
import { REACT_APP_STRAPI_API_URL } from "constants/endpoints"
// types
import { Pagination } from "types/api"

export type ExternalCertificatePaymentStatus = "PAID" | "OPEN"

export type ExternalCertificateProgress = {
  id: number
  documentId: string
  paymentStatus: ExternalCertificatePaymentStatus
  super_course: {
    id: number
  }
}

export type GetExternalCertificateProgressesResponse = {
  data: ExternalCertificateProgress[]
  meta: Pagination
}

export const EXTERNAL_CERTIFICATE_PROGRESS_KEYS = Object.freeze({
  GET_EXTERNAL_CERTIFICATE_PROGRESSES: "externalCertificateProgresses",
})

export const getExternalCertificateProgresses = async () => {
  const params = qs.stringify(
    {
      populate: {
        super_course: {
          fields: ["id"],
        },
      },
    },
    { encodeValuesOnly: true }
  )

  const url = `${REACT_APP_STRAPI_API_URL}external-certificate-progresses?${params}`

  const response = await axios.get<GetExternalCertificateProgressesResponse>(url)

  return response.data
}
